type MegaphoneIconProps = {
  size?: number
}

export function MegaphoneIcon({ size = 24 }: MegaphoneIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24.0001 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M19.7036 2.39502C20.6005 1.88251 21.7172 2.53002 21.7173 3.56299V17.4478C21.7172 18.4807 20.6005 19.1282 19.7036 18.6157L13.7954 15.2397H11.8657L12.4185 19.1099C12.6526 20.7488 11.3807 22.2153 9.7251 22.2153C8.37138 22.2151 7.22319 21.2195 7.03174 19.8794L6.36182 15.1929C4.05794 14.8734 2.28373 12.8972 2.28369 10.5054C2.28374 7.89114 4.4029 5.77221 7.01709 5.77197H13.7954L19.7036 2.39502ZM8.51123 19.6685C8.59763 20.272 9.11544 20.72 9.7251 20.7202C10.4708 20.7202 11.0432 20.06 10.938 19.3218L10.355 15.2397H7.87939L8.51123 19.6685ZM14.7407 6.95264V14.0581L20.2222 17.1899V3.81982L14.7407 6.95264ZM7.01709 7.26611C5.22851 7.26635 3.77788 8.71674 3.77783 10.5054C3.77788 12.294 5.22851 13.7444 7.01709 13.7446H13.2456V7.26611H7.01709Z" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
    </svg>
  )
}
